import script from "./BaseAuthForm.vue?vue&type=script&lang=ts"
export * from "./BaseAuthForm.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__